import React, { Component } from 'react';
import { LargeButton } from './common/Buttons';
import mfaFailIcon from "../images/mfa-failed.png";
import { t } from "./helper/ClientAppLocalizer";


export class Lockout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            redirectToLogin: false
          };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }
    componentDidMount() {
        setTimeout(function () { //Start the timer
            this.button.click();
        }.bind(this),5000)

    }

    openModal() {
        this.setState({modalIsOpen: true});
    }
    
    closeModal() {
        this.setState({modalIsOpen: false});
    }

    handleContinue = () => {
        this.button.setAttribute("disabled", "disabled");
        window.location.href = this.props.dayforceLoginUrl;
    }
    
    render() {
        const lockoutMessage = t("SystemMessages:DefaultLockoutMessage");
        return (
            <div>
                {
                    // The image needs to be replaced with a high-res one. We don't have that image yet.
                }
                <img id="topImage" alt={t("Authy.DayforceLogo")} src={mfaFailIcon} style={{maxHeight:120, maxWidth:120, alignContent: 'center', marginBottom: 50}} />

                <div style={{ marginBottom: 20, color: 'red' }}>
                    {/*(this.props.lockoutMessage.trim() != "") ? this.props.lockoutMessage :  lockoutText */}
                    {lockoutMessage}
                 </div>
                
                <LargeButton id="lockOutTryAgain" ref={button => this.button = button} onClick={this.handleContinue} style={{ align: 'center' }}>{t("Continue")}</LargeButton><br/>                

            </div>
        );
    }
}